export enum ClickHelperEventType {
    Clicked = 'clicked',
    StateChanged = 'state-changed',
}
